export enum RemittanceStatus {
  SUCCESSFUL = "Successful",
  FAILED = "Failed",
}

export const remittanceStatusList = [
  { value: RemittanceStatus.SUCCESSFUL, label: "Successful", color: "green" },
  { value: RemittanceStatus.FAILED, label: "Failed", color: "red" },
];
